import { useOnboarding } from '../../hooks/useOnboarding';
import { OnboardingTrigger } from './OnboardingTrigger';
import { OnboardingTOC } from './OnboardingTOC';
import { WelcomePrompt } from './WelcomePrompt';

interface OnboardingProviderProps {
  children: React.ReactNode;
}

export function OnboardingProvider({ children }: OnboardingProviderProps) {
  // Initialize the onboarding hook (handles tour execution)
  useOnboarding();

  return (
    <>
      {children}
      <WelcomePrompt />
      <OnboardingTOC />
      <div data-onboarding="help-trigger">
        <OnboardingTrigger />
      </div>
    </>
  );
}
